export default __webpack_public_path__ + "static/media/chat.ccdea250.svg";